// Custom JS applied last.
(() => {
  const $ = (selector) => [...document.querySelectorAll(selector)];

  document.addEventListener('DOMContentLoaded', () => {
    /** @type {HTMLTextAreaElement | null} */
    const cartNotes = $('#main-cart-footer .cart__note textarea')?.[0];
    if (cartNotes) {
      cartNotes.placeholder = 'Hoping to bring a smile to your day!\n- Alex';
      cartNotes.maxLength = 150;
    }

    /** @type {HTMLTextAreaElement | null} */
    const cartDetails = $('#main-cart-footer #additional-details-input')?.[0];
    if (cartDetails) {
      cartDetails.placeholder = 'Call upon arrival';
      cartDetails.maxLength = 150;
    }
  });
})();
